import CustomerDataAddress from 'mage-swagfaces/customer/CustomerDataAddress';
import React from 'react';
import ReviewAddressTile from './ReviewAddressTile';
import ReviewPaymentTile from './ReviewPaymentTile';
import { ReviewWrapper } from './styled';
import { useSelector } from 'react-redux';
import { isVirtualCartSelector } from 'store/cart/selectors';
import { Show } from 'components/Functional';
import { CartPaymentMethod } from 'helpers/billing';
import { TrackingProp } from 'react-tracking';

interface CheckoutReviewTilesProps {
  tracking: TrackingProp;
  cartId: number;
  shippingAddr: CustomerDataAddress;
  cartPaymentMethods: CartPaymentMethod[];
  paymentLoading?: boolean;
  shippingLoading: boolean;
  openShippingAddressSelectionModal?: () => void;
  openPaymentMethodSelectionModal?: () => void;
  showSelectedMethod?: 'creditcard' | 'paypal';
}

const CheckoutReviewTiles = ({
  tracking,
  cartId,
  shippingAddr,
  cartPaymentMethods,
  paymentLoading,
  shippingLoading,
  openShippingAddressSelectionModal,
  openPaymentMethodSelectionModal,
  showSelectedMethod
}: CheckoutReviewTilesProps): React.JSX.Element => {
  const isVirtualCart = useSelector(isVirtualCartSelector);

  return (
    <ReviewWrapper>
      <Show when={!isVirtualCart}>
        <ReviewAddressTile
          isLoading={paymentLoading || shippingLoading}
          address={shippingAddr}
          handleChangeClick={openShippingAddressSelectionModal}
          tracking={tracking}
          cartId={cartId}
        />
      </Show>
      <ReviewPaymentTile
        isLoading={paymentLoading || (!isVirtualCart && shippingLoading)}
        tracking={tracking}
        cartId={cartId}
        showSelectedMethod={showSelectedMethod}
        cartPaymentMethods={cartPaymentMethods}
        handleChangeClick={openPaymentMethodSelectionModal}
      />
    </ReviewWrapper>
  );
};

export default CheckoutReviewTiles;
